module.exports = __webpack_public_path__ + "static/media/ExcelSearchRehberi.4dafa3ae.pdf";